<template>
  <div>
    <div class="content">
        <div class="user-left">
          <div style="width:150px;">
            <upload ref="upload" :length="1" :imgs="image" @uploadSuccess="uploadSuccess" :cutImg="true" :uploadTest="$t('上传证件照')" :fixedNumber="[5,7]"></upload>
          </div>
          <div class="row" style="width: 100%;">
            <div style="position: relative;">
              <!-- <a-input :addon-before="$t('选手姓名')" :style="{width: '100%'}" v-model="formPost.name" :addon-after="'* ' + $t('必填')" :placeholder="$t('请输入姓名')" /> -->
              <a-input :addon-before="$t('选手姓名')" v-model="formPost.name" :addon-after="'* ' + $t('必填')" :placeholder="$t('输入姓名')" />
              <div class="change-player">
                <div v-for="(item,index) in playerList" :key="index" class="change-li" @click="changePlayer(item)">
                  <img :src="item.image"/>&ensp;&ensp;{{ item.name }}
                </div>
              </div>
            </div>
            <a-input disabled :addon-before="formPost.nationality=='中国大陆'? $t('身份证号') : $t('护照号')" v-model="formPost.card" :addon-after="'* ' + $t('必填')" :placeholder="formPost.nationality=='中国大陆'?$t('请输入身份证号'):$t('请输入护照号')" />
            <div class="col-row" v-if="formPost.nationality!='中国大陆'">
              <a-date-picker disabled v-model="formPost.birthday" @change="birthdayChange" class="col-2" placeholder="请选择出生日期"/>
              <a-select disabled style="width:200px;" v-model="formPost.sex" placeholder="请选择性别">
                <a-select-option :value="1">男</a-select-option>
                <a-select-option :value="2">女</a-select-option>
              </a-select>
            </div>
            <div style="overflow: hidden;">
              <div v-for="(item,index) in enclosureList" :key="index" style="width: 80px;float: left;text-align: center;">
                <a-upload
                  name="file"
                  :action="imgurl"
                  listType="text"
                  :showUploadList="false"
                  @change="handleChangeImage($event, item)"
                >
                  <div>
                    <img v-if="formPost.enclosure[item.name]" :src="formPost.enclosure[item.name]" style="width:32px;height:32px;">
                    <img v-else src="@comm/assets/img.png">
                    <div class="ant-upload-text">{{ item.ismust ? '*' : '' }}{{ item.name }}</div>
                  </div>
                </a-upload>
              </div>
            </div>
            <p v-if="matchInfo.notesDes && enclosureList.length > 0">附件须知：{{ matchInfo.notesDes }}</p>
          </div>
        </div>
      <div class="user-right">
        <div class="jc-warp">
          <div class="text">{{ checkObj.msg }}</div>
          <!-- <div class="btn" @click="userDetection()">{{ $t('点击检测，获取项目') }}</div> -->
        </div>
      </div>
    </div>
    <div style="overflow: hidden;">
      <div v-for="(item,index) in informationList" :key="index" style="width: 280px;float: left;margin-right:20px;margin-top:10px;">
        <a-input style="width:100%;" :placeholder="'请输入' + item.name" v-model="formPost.information[item.name]" :addon-before="item.name" :addon-after="item.ismust ? '*必填' : ''"/>
      </div>
    </div>
    <!-- <a-alert style="margin-top:10px;" v-if="checkObj.type === 0" :message="$t('请录入运动员信息后，点击检测')" type="warning" show-icon /> -->
    <a-alert style="margin-top:10px;" v-if="checkObj.type === 1 && data.length ===  0" :message="$t('没有检测到符合年龄的项目')" type="info" show-icon />
    <a-spin :spinning="spinning" tip="项目检测中...">
      <SelectProject :itemData="item" :dataList="data" :agencyId="agencyId" :teamId="teamId" :combatTerm="combatTerm" :detailWeight="detailWeight" @changeData="changeData" />
      <div class="submit-btn" v-if="data.length > 0">
        <!-- <p>{{ $t('注：提交之前请检查所报项目，以免错报或误报！') }}</p> -->
        <div class="btn top20" @click="submit">{{ $t('报名提交') }}</div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import Upload from '@comm/upload/Upload'
import PlayerType from '@comm/config/high-tech/PlayerType'
import nationalityUtil from '@comm/utils/nationalityUtil'
import {checkIdCard, getBirthday, getSex} from '@comm/utils/IdCardUtils'
import config from '@comm/http/config'
import matchFun from '@comm/utils/matchFun'
import SelectProject from './SelectProject'
export default {
  components: {
    SelectProject,
    Upload
  },
  props: {
    item: {
      type: Object
    },
    agencyId: {
      type: Number
    },
    teamId: {
      type: Number
    }
  },
  data () {
    return {
      nationalityArr: nationalityUtil,
      PlayerType: PlayerType,
      matchFun: matchFun,
      imgurl: config.baseImgURL,
      matchInfo: store.getters['match/matchInfo'],
      programId: Number(this.$route.query.programId),
      formPost: {
        matchId: this.$route.query.matchId,
        agencyId: null,
        teamId: null,
        nationality: '中国大陆',
        type: undefined,
        image: '',
        name: '',
        combatId: {},
        combatDetailId: {},
        video: {},
        card: '',
        birthday: '',
        sex: 1,
        cardId: -1,
        enclosure: {},
        information: {}
      },
      checkObj: {
        type: 0,
        msg: '检测通过，自动获取身份证信息'
      },
      playerList: [],
      enclosureList: [],
      informationList: [],
      data: [],
      image: [],
      bigImage: [],
      combatTerm: [],
      spinning: false,
      detailWeight: {}
    }
  },
  computed: {
    ...mapState({
      accountId: state => state.user.accountId,
      coachId: state => state.join.coachId
    })
  },
  mounted () {
    this.formPost.agencyId = this.agencyId
    this.formPost.teamId = this.teamId
    this.findAdditional()
    this.queryCombatTerm()
    if(this.item){
      this.changePlayer(this.item)
      this.userDetection()
    }
    
  },
  methods: {
    findAdditional () {
      this.$api.join.findAdditional({matchId: this.$route.query.matchId}).then(res => {
        if (res.status === 0) {
          this.enclosureList = JSON.parse(res.data.enclosure)
          this.informationList = JSON.parse(res.data.information)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 查询项目兼项配置情况
    queryCombatTerm () {
      this.$api.match.combatTermList(this.$route.query.matchId).then(res => {
        if (res.status === 0) {
          this.combatTerm = res.data || []
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    handleChangeImage (info, item) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (fileList[0].response) {
        this.formPost.enclosure[item.name] = fileList[0].response.data.url
        item.image = fileList[0].response.data.url
        this.$forceUpdate()
      }
    },
    transformFile (file) {
      console.log(file)
    },
    handleSearch (value) {
      this.empty()
      if (value.target.value === '') {
        this.playerList = []
        return
      }
      this.$api.join.queryPlayersByKeyWords({agencyId: this.agencyId, accountId: this.accountId, keyWords: value.target.value}).then(res => {
        if (res.status === 0) {
          this.playerList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    empty () {
      this.data = []
      this.image = []
      this.bigImage = []
      this.formPost.enclosure = {}
      this.formPost.video = {}
      this.formPost.information = {}
      this.checkObj = {
        type: 0,
        msg: '检测通过，自动获取身份证信息'
      }
      this.formPost.image = ''
      this.formPost.bigImage = ''
      this.formPost.type = undefined
      this.formPost.card = ''
      this.formPost.cardId = -1
      this.formPost.birthday = ''
      this.formPost.sex = 1
    },
    changePlayer (item) {
      this.formPost.name = item.name
      this.formPost.type = item.type === null ? undefined : item.type
      this.formPost.nationality = item.nationality
      if (item.image !== null) {
        this.image = [this.matchFun.randomNumFile('image.jpg', item.image)]
        this.formPost.image = item.image
      } else {
        this.image = []
        this.formPost.image = null
      }
      // this.image = []
      // this.formPost.image = null
      this.bigImage = []
      this.formPost.bigImage = item.bigImage
      this.formPost.card = item.card
      this.formPost.cardId = item.cardId === null ? -1 : item.cardId
      this.formPost.birthday = item.birthday
      this.formPost.sex = item.sex
      this.playerList = []
      if (item.cardId) {
        this.$api.join.findCardAdditional({matchId: this.$route.query.matchId, cardId: item.cardId}).then(res => {
          if (res.status === 0) {
            this.formPost.enclosure = JSON.parse(res.data.enclosure)
            this.formPost.information = JSON.parse(res.data.information)
          }
        }).catch(err => {
          console.log(err)
        })
      }
      this.userDetection()
      // 如果是线上比赛，查询已上传的视频
      if (this.matchInfo.mode === 'ONLINE') {
        this.$api.join.findCardVideo({matchId: this.$route.query.matchId, cardId: item.cardId}).then(res => {
          if (res.status === 0) {
            this.formPost.video = res.data
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    userDetection () { // 点击检测
      if (this.formPost.nationality == '中国大陆') {
        if (this.formPost.card === '') {
          this.$message.error('身份证号码不能为空')
          return
        }
        if (this.formPost.card && checkIdCard(this.formPost.card)) {
          this.formPost.birthday = getBirthday(this.formPost.card)
          this.formPost.sex = getSex(this.formPost.card)
          this.checkObj = {
            type: 1,
            msg: '出生年月：' + this.formPost.birthday + ' 性别：' + (this.formPost.sex === 1 ? '男' : '女')
          }
          this.detection({matchId: this.formPost.matchId, birthday: this.formPost.birthday, sex: this.formPost.sex, cardId: this.formPost.cardId, agencyId: this.agencyId})
        } else {
          this.$message.error('身份证号码不正确')
        }
      } else {
        if (this.formPost.sex && this.formPost.birthday) {
          this.checkObj = {
            type: 1,
            msg: '出生年月：' + this.formPost.birthday + ' 性别：' + (this.formPost.sex === 1 ? '男' : '女')
          }
          this.detection({matchId: this.formPost.matchId, birthday: this.formPost.birthday, sex: this.formPost.sex, cardId: this.formPost.cardId, agencyId: this.agencyId})
        } else {
          this.$message.error('出生年月和性别不能为空')
        }
      }
    },
    detection (valDate) { // 点击检测，获取项目
      this.spinning = true
      this.data = []
      this.$api.join.findCombatDetailByCard(valDate).then(res => {
        this.spinning = false
        if (res.status === 0) {
          this.data = res.data
          if (this.data.length == 0) {
            this.$message.error('未检测到符合条件的项目')
          }
          this.$forceUpdate()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    birthdayChange (date, dateString) { // 日期选择器
      this.formPost.birthday = dateString
    },
    changeData (data) {
      this.data = data
    },
    uploadSuccess (e) {
      this.image = e
      if (this.image.length > 0) {
        this.formPost.image = this.image[0].url
      } else {
        this.formPost.image = ''
      }
    },
    uploadSuccessBig (e) {
      this.bigImage = e
      if (this.bigImage.length > 0) {
        this.formPost.bigImage = this.bigImage[0].url
      } else {
        this.formPost.bigImage = ''
      }
    },
    submit () {
      if (this.formPost.name === '') {
        this.$message.error('请输入运动员的名称')
        return
      }
      if (this.formPost.nationality == '中国大陆') {
        // 去除空格
        this.formPost.name = this.formPost.name.replace(/\s+/g, '')
      } else {
        // 去除两边的空格
        this.formPost.name = this.formPost.name.trim()
        this.formPost.card = this.formPost.card.replace(/\s+/g, '')
      }
      
      if (this.formPost.card === '') {
        this.$message.error('请输入运动员的证件号码')
        return
      }
      if (this.formPost.image === '' && !this.matchInfo.imageIsRequired.player) {
        this.formPost.image = 'https://static.daoba.com//838779651131.jpg'
      }
      if (this.formPost.image === '') {
        this.$message.error('请上传运动员的证件照')
        return
      }
      if ((this.formPost.bigImage === null || this.formPost.bigImage === '')) {
        this.formPost.bigImage = this.formPost.image
      }
      let bool = false
      this.enclosureList.forEach(element => {
        if (element.ismust && !this.formPost.enclosure[element.name]) {
          this.$message.error('请上传附件' + element.name)
          bool = true
        }
      })
      this.informationList.forEach(element => {
        if (element.ismust && !this.formPost.information[element.name]) {
          this.$message.error('请填写' + element.name)
          bool = true
        }
      })
      if (bool) {
        return
      }
      // 不是高新区的项目类型设置为0
      this.formPost.type = 0
      this.formPost.customerId = this.accountId
      this.formPost.joinLeaderStaffs = ''
      this.formPost.combatId = {}
      this.formPost.combatDetailId = {}
      this.formPost.detailWeight = {}
      let videoBool = false
      let titleName = ''
      // this.data 循环  check_select有值表示已选中，然后里面的Limit表示选中的下拉数字，如没有Limit表示0
      this.data.forEach((item, index) => {
        item.details.forEach((cItem, cIndex) => {
          if (cItem.checkSelect) {
            if (titleName != '' && titleName != cItem.detailName && cItem.detailName != '丁组' && titleName != '丁组') {
              this.$message.error('只能选择一种组别报名，您选择了【' + titleName + '，' + cItem.detailName + '】')
              videoBool = true
            }
            titleName = cItem.detailName
            this.formPost.combatId[cItem.checkSelect] = item.combatId
            this.formPost.combatDetailId[cItem.checkSelect] = cItem.curTeamNumber
            if (JSON.parse(item.rule).isFillWeight && !this.detailWeight[cItem.checkSelect]) {
              this.$message.error('请填写您真实的体重')
              videoBool = true
            }
            this.formPost.detailWeight[cItem.checkSelect] = this.detailWeight[cItem.checkSelect]
            if (this.matchInfo.mode === 'ONLINE') {
              if (item.video || this.formPost.video[cItem.checkSelect]) {
                this.formPost.video[cItem.checkSelect] = item.video ? item.video : this.formPost.video[cItem.checkSelect]
              } else {
                this.$message.error('请上传' + item.combatName + cItem.detailName + cItem.weight + '线上比赛视频')
                videoBool = true
              }
            }
          }
        })
      })
      if (Object.keys(this.formPost.combatId).length === 0 || Object.keys(this.formPost.combatDetailId).length === 0) {
        this.$message.error('请先选择要参加的项目')
        return
      }
      if (videoBool) {
        return
      }
      this.spinning = true
      this.$api.join.joinNormal(this.formPost).then(res => {
        this.spinning = false
        if (res.status === 0) {
          this.$message.success('成功')
          this.signUrl()
          this.$emit('ok', 1)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    signUrl () {
      this.formPost.name = ''
      this.empty()
    }
  },
  watch: {
    item (newValue, oldValue) {
      if (newValue != null) {
        this.changePlayer(newValue)
        this.userDetection()
      } else {
        this.empty()
      }
      
    }
  }
}
</script>
<style lang="scss" scoped>
.submit-btn {
  text-align: center;
  margin-top: 20px;
  .btn{
    color: #fff;
    width: 150px;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
    right: 250px;
    bottom: 29px;
    text-align: center;
    border-radius: 2px;
    background-color: #b80000;
    cursor:pointer;
    display: inline-block;
    font-size: 16px;
  }
}
.or-title{
  color: #000;
  height: 50px;
  font-size: 16px;
  position: relative;
  .border-left{
    padding: 0 10px;
  }
  .add-right{
    cursor: pointer;
    position: absolute;
    right: 0;
    color: #000;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
  }
}
.content{
  display: flex;
  background-color: #fff;
    border-radius: 2px;
    box-shadow: rgba(196, 196, 196, 0.5) 1px 1px 3px 1px;
    .col-check{
      height: 40px;
      float: left;
      margin: 7px;
      display: flex;
      align-items: center;
      border-radius: 2px;
    }
    .input-width{
      width: 70px;
    }
  .user-left{
    flex: 1;
    display: flex;
    flex-direction: row;
    padding: 20px;
    .up-img{
      width: 100px;
      height: 120px;
      border:1px solid #e8e8e8;
      border-radius: 2px;
      background-color: #e8e8e8;
      background-image: url('../../../../comm/assets/add.png');
      background-position: center;
      background-repeat: no-repeat;
    }
    .row{
      line-height: 40px;
    }
    .col-row{
      display: flex;
      .col-1{
        flex: 1;
        display: flex;
        align-items: center;
        img{
          width: 25px;
          height: 25px;
          border-radius: 2px;
          margin-right: 5px;
          border: 1px solid #e8e8e8;
        }
      }
      .col-2{
        flex: 2;
        padding-right: 5px;
      }
    }
  }
  .user-right{
    flex: 1;
    padding: 20px 0;
    .jc-warp{
      width: 550px;
      display: flex;
      height: 35px;
      line-height: 35px;
    }
    .text{
      text-align: center;
      background-color: #e8e8e8;
      width: 350px;
      border: 1px dashed #ccc;
      border-right: none;
    }
    .btn{
      cursor: pointer;
      width: 200px;
      text-align: center;
      background: #b80000;
      color: #fff;
    }
    .hint{
      text-align: center;
      color: #999;
      padding-right: 30px;
      padding-top: 10px;
      font-size: 13px;
    }
  }
}
.content /deep/ .ant-upload.ant-upload-select-picture-card{
  height: 126px;
}
.content /deep/ .ant-upload-list-picture-card .ant-upload-list-item{
  height: 126px;
}
.change-player{
  position: absolute;top:32px;left:80px;z-index:9;background:white;max-height: 200px;overflow: auto;width: 160px;
}
.change-li{
  border-bottom:1px solid #ccc;padding: 5px 20px;cursor: pointer;
}
.change-li img {
  width:30px;height:30px;border-radius:5px;
}
.change-li:hover{
  background: rgba(0,0,0,0.1);
}

</style>



// WEBPACK FOOTER //
// src/comm/components/join/joinFactory/SelectJoinPlayer.vue